import { NodeSelection } from '@tiptap/pm/state';

import { liquidInlineContent, LIQUID_VARIABLE_NODE } from '../extensions/liquidVariableNodes';
import { getVariableToken } from './emailVariableCatalog';
import type { Editor } from '@tiptap/core';

export const BUTTON_NODE_TYPE = 'button';

const buttonAt = (editor: Editor, pos: number) => {
	const node = editor.state.doc.nodeAt(pos);
	return node && node.type.name === BUTTON_NODE_TYPE ? node : null;
};

export const readButtonText = (editor: Editor, pos: number): string => {
	const node = buttonAt(editor, pos);
	if (!node) {
		return '';
	}

	let text = '';
	node.forEach((child) => {
		text +=
			child.type.name === LIQUID_VARIABLE_NODE
				? getVariableToken(String(child.attrs.name ?? ''))
				: child.textContent;
	});
	return text;
};

export const writeButtonText = (editor: Editor, pos: number, text: string): void => {
	const node = buttonAt(editor, pos);
	if (!node) {
		return;
	}

	const from = pos + 1;
	const to = pos + node.nodeSize - 1;
	const content = liquidInlineContent(text).map((json) => editor.schema.nodeFromJSON(json));
	const transaction = content.length
		? editor.state.tr.replaceWith(from, to, content)
		: editor.state.tr.delete(from, to);

	transaction.setSelection(NodeSelection.create(transaction.doc, pos));
	editor.view.dispatch(transaction);
};
